import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { device, Row, TagFilterCheckbox } from '@landsbankinn/ui';
import React from 'react';
import { BranchServices } from '../../../../__generated__/globalTypes';
import { CheckboxContainer } from './AtmFilter';
import res from './BranchServicesFilter.res';

interface IProps {
  selectedServices: BranchServices[];
  setBranchServices: React.Dispatch<React.SetStateAction<BranchServices[]>>;
}

const StyledTagFilterCheckbox = styled(TagFilterCheckbox)`
  width: 100%;
  margin-right: 20px;
  margin-bottom: 20px;
  @media ${device.tablet} {
    width: 220px;
  }
`;

const Host = styled(Row)`
  margin-bottom: 40px;
`;

export const BranchServicesFilter: React.FC<IProps> = ({
  setBranchServices,
  selectedServices,
}) => {
  const { r } = useResource();
  const services = () => {
    const services: BranchServices[] = [];
    for (const service in BranchServices) {
      const myService: BranchServices = BranchServices[
        service
      ] as BranchServices;
      if (
        service !== BranchServices.MailDelivery &&
        service !== BranchServices.ServiceVisit
      ) {
        services.push(myService);
      }
    }

    return services.sort((a, b) => {
      if (b === BranchServices.CorporateBankingService) {
        return -1;
      }
      if (
        a === BranchServices.RetailBankingService ||
        a === BranchServices.CashierService
      ) {
        return -1;
      }
      return 1;
    });
  };

  return (
    <Host>
      {services().map((service) => {
        if (res[service]) {
          return (
            <CheckboxContainer key={service}>
              <StyledTagFilterCheckbox
                id={service}
                checked={selectedServices.includes(service)}
                label={r(res[service])}
                onChange={(checked) => {
                  if (checked) {
                    setBranchServices([...selectedServices, service]);
                    return;
                  }
                  setBranchServices(
                    selectedServices.filter((i) => i !== service),
                  );
                }}
              />
            </CheckboxContainer>
          );
        }
      })}
    </Host>
  );
};
